import type { FC, ReactNode } from 'react';
import { stylesheet } from 'typestyle';
import { headerHeight } from '../../../app.styles';
import { LoadingOverlay } from '../../../components/LoadingOverlay';

export type SidebarContainerProps = {
  isLoading?: boolean;
  children?: ReactNode;
};

const css = stylesheet({
  podSidebarContainer: {
    $nest: {
      '.pod-sidebar-sticky': {
        position: 'sticky',
        top: headerHeight + 20,
      },
    },
  },
});

export const SidebarContainer: FC<SidebarContainerProps> = ({ children, isLoading = false }) => (
  <div className={css.podSidebarContainer} role="menu">
    <fieldset className="pod-sidebar-sticky" data-cy="tp-sidebar-fieldset" disabled={!!isLoading}>
      <div className="position-relative" data-cy="pod-menu">
        {children}
        <LoadingOverlay visible={isLoading} />
      </div>
    </fieldset>
  </div>
);
